export const CONSUMER_CHART_YEAR_FETCH = 'CONSUMER_CHART_YEAR_FETCH';
export const CONSUMER_CHART_SELLER_FETCH = 'CONSUMER_CHART_SELLER_FETCH';
export const CONSUMER_SELLERS_FETCH = 'CONSUMER_CHART_SELLER_LIST_FETCH';
